export const SEND_FILE_ROUTE = '/player/proxy/upload_diploma';
export const SEND_FILE = 'SEND_FILE';
export const SEND_FILE_SUCCESS = 'SEND_FILE_SUCCESS';